
import { BinaryFunction } from "../../../math/BinaryFunction";
import { AudioBufferChannelReader } from "../../AudioBufferChannelReader";
import { WaveLevelData } from "./WaveLevelData";
import { WaveLevels } from "./WaveLevels";

export class WaveFormBlockReader
{
  private _levelBuffers:Float32Array[];
  private _reader:AudioBufferChannelReader;
  private _compress:BinaryFunction;
  private _maxSamples = 0;

  constructor( numLevels:number )
  {
    this._createBuffers( numLevels );
  }


  compressAndCopyTo( compressor:BinaryFunction, levels:WaveLevels, sampleOffset:number )
  {
    this.setCompressor( compressor );
    this.computeLevels();
    levels.setData( this, sampleOffset );
  }

  setCompressor( compress:BinaryFunction )
  {
    this._compress = compress;
  }  

  

  setReader( reader:AudioBufferChannelReader )
  {
    this._reader = reader;
  }

  get numLevels()
  { 
    return this._levelBuffers.length;
  }

  get numSamples()
  {
    return this._maxSamples;
  }

  private _createBuffers( numLevels:number )
  {
    this._levelBuffers = [];

    this._maxSamples = Math.pow( 2, numLevels );;

    for ( let i = 0; i < numLevels; i++ )
    {      
      let numSamplesPerLevel = Math.pow( 2, numLevels - i );
      var data = new Float32Array( numSamplesPerLevel );
      this._levelBuffers.push( data );

      console.log( `Creating buffer for level ${i} with samples ${numSamplesPerLevel}`);      
    }
  }

  get( index:number ):Float32Array
  {
    return this._levelBuffers[ index ];
  } 

  readData( reader:AudioBufferChannelReader, buffer:AudioBuffer, offset:number )
  {
    this.setReader( reader );
    this.read( buffer, offset );
  }

  read( buffer:AudioBuffer, offset:number )
  {
    let firstLevel = this._levelBuffers[ 0 ];
    let numSamples = buffer.getChannelData( 0 ).length;

    let start = offset;
    let end   = start + firstLevel.length;
    
    if ( end > numSamples )
    {
      let difference = end - numSamples; 

      for ( let i = 0; i < difference; i++ )
      {
        let index = ( numSamples - 1 ) - i;
        firstLevel[ index ] = 0;
      }      

      end = numSamples;
    } 

    let sampleLength = end - start;

    this._reader.sampleTo( buffer, offset, firstLevel, 0, sampleLength );
  }

  computeLevels()
  {
    let maxLevel = this._levelBuffers.length - 1;

    for ( let i = 0; i < maxLevel; i++)
    {
      var higherLevel = this._levelBuffers[ i ];
      var lowerLevel  = this._levelBuffers[ i + 1 ];
      
      this._getCompressedLevel( higherLevel, lowerLevel );
    }
  }

  private _getCompressedLevel( higher:Float32Array, lower:Float32Array )
  {
    //let infoFrequency = Math.round( lower.length / 10 );

   // console.log( "compute level", higher.length, lower.length );

    for ( let i = 0; i < lower.length; i++ )
    {
      let indexA = i * 2;
      let indexB = indexA + 1;

      let dataA = higher[ indexA ];
      let dataB = higher[ indexB ];

      lower[ i ] = this._compress( dataA, dataB );

      /*if ( i % infoFrequency === 0 )
      {
        console.log( `${Math.round(100*i/lower.length)} ${i} => ${indexA}:${indexB} = [${dataA}:${dataB}]. Compressed => ${lower[i]}`)
      }*/
    }
  }
  
}
